<template>
  <div class="payments">
    <div class="payments__header filters-bar">
      <payments-filter />
      <i-button
        v-if="getContractModulePerms('contract_payments', 'create')"
        type="success"
        @click="createPayment"
        >Создать платеж</i-button
      >
    </div>
    <card dis-hover :padding="8" class="payments__stats stats-block special">
      <inline-loader :loading="statsLoading" v-if="statsLoading" />
      <payments-stats v-else-if="stats" :stats="stats" />
    </card>
    <inline-loader :loading="loading" v-if="loading && !nodata" />
    <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
      Не удалось загрузить список платежей. Повторите, пожалуйста, попытку позже
    </div>
    <payments-list
      :payments="payments"
      @open-payment="openPayment"
      v-else-if="payments.length"
    />
    <div v-else class="ms-nodata ms-text">
      Платежи отсутствуют
    </div>

    <modal
      v-if="!loading"
      class-name="payments-editor editor-modal"
      v-model="paymentModal"
      width="420"
      :styles="{ top: '40px' }"
      :mask-closable="false"
    >
      <payments-editor-header slot="header" :payment="payment" />
      <div class="payments-editor__container">
        <alert
          style="margin-top: 16px;"
          v-if="editorState.warning"
          class="alerts-item"
          type="warning"
        >
          {{ editorState.warning }}
        </alert>
        <payments-editor-act
          :payment="payment"
          :roadmap="roadmap"
          :acts="acts"
          :payment-modal="paymentModal"
          :current-max-value="currentMaxValue"
        />
        <payments-editor-costs
          :payment="payment"
          :current-max-value="currentMaxValue"
        />
      </div>
      <div slot="footer" class="payments-editor__buttons">
        <i-button
          :disabled="
            !payment.id ||
            !getContractModulePerms('contract_payments', 'delete')
          "
          type="error"
          size="default"
          :loading="deleting"
          @click="deletePayment"
        >
          Удалить
        </i-button>
        <i-button
          type="success"
          size="default"
          :loading="saving"
          @click="savePayment"
          :disabled="
            editorState.disabled ||
            !getContractModulePerms('contract_payments', 'update')
          "
        >
          Сохранить
        </i-button>
      </div>
    </modal>
  </div>
</template>

<script>
import moment from 'moment'
import cloneDeep from 'lodash.clonedeep'
import PaymentsList from '@/components/payments/payments-list'
import InlineLoader from '@/components/loaders/inline-loader'
import PaymentsStats from '@/components/stats/payments-stats'
import PaymentsEditorHeader from '@/components/payments/editor/payments-editor-header'
import PaymentsEditorAct from '@/components/payments/editor/payments-editor-act'
import PaymentsEditorCosts from '@/components/payments/editor/payments-editor-costs'
import PaymentsFilter from '@/components/filters/payments'
import { getFormattedCosts, formatDefaultDate, round } from '@/utils'
import { payment } from '@/config/payments'
import { getPaymentsUrl } from '@/config/filters'

export default {
  props: ['type'],
  components: {
    PaymentsList,
    InlineLoader,
    PaymentsStats,
    PaymentsEditorHeader,
    PaymentsEditorAct,
    PaymentsEditorCosts,
    PaymentsFilter
  },
  data () {
    return {
      stats: null,
      statsLoading: false,
      loading: false,
      nodata: false,
      roadmap: [],
      acts: [],
      payments: [],
      contract: null,
      paymentModal: false,
      deleting: false,
      saving: false,
      payment
    }
  },
  computed: {
    editorState () {
      const { date, value, act_id, type_id, roadmap_payments } = this.payment
      const { prepaid } = this.contract

      if (type_id !== 2 && !act_id) {
        return {
          disabled: true,
          warning: 'Необходимо указать акт, по которому производится платеж'
        }
      }

      // prepaid payment
      if (type_id === 2 && !prepaid) {
        return {
          disabled: true,
          warning:
            'Аванс отключен. Необходимо настроить информацию об авансе в карточке проекта'
        }
      }

      if (type_id === 2 && !roadmap_payments.length) {
        return {
          disabled: true,
          warning:
            'Необходимо указать этапы работ, по которым производится платеж'
        }
      }

      if (type_id === 2 && roadmap_payments.some((r) => !r.value)) {
        return {
          disabled: true,
          warning:
            'Необходимо указать сумму платежа для каждого из выбранных этапов'
        }
      }

      // common field
      if (!date || !value) {
        return {
          disabled: true,
          warning: 'Необходимо указать сумму и дату платежа'
        }
      }

      if (value > this.currentMaxValue) {
        return {
          disabled: true,
          warning: 'Сумма платежа не может превышать сумму акта или аванса'
        }
      }

      return {
        disabled: false,
        warning: null
      }
    },
    currentMaxValue () {
      const { type_id, act_id, id } = this.payment
      const { prepaid_amount, prepaid_payments_amount } = this.contract

      // prepaid max value
      if (type_id === 2) {
        const { roadmap_payments } = this.payment
        const activeRoadmaps = roadmap_payments.filter((r) => !r.disabled)
        const costs = activeRoadmaps.reduce((prev, el) => prev + el.value, 0)

        return round(prepaid_amount - prepaid_payments_amount + costs, 2)
      }
      // empty act_it -> return 0
      if (!act_id) return 0

      const act = this.acts.find((a) => a.id === this.payment.act_id)

      if (id) return round(act.debt_payments + act.payments, 2)

      return round(act.debt_payments, 2)
    }
  },
  // watch: {
  //   '$store.state.filters.payments': {
  //     handler: function () {
  //       this.getPayments()
  //     },
  //     deep: true
  //   },
  //   '$store.state.socket': {
  //     handler: function (val) {
  //       if (!val.create && !val.update && !val.delete) return
  //       const { type } = this.$store.state.socket

  //       if (type === 'payments' || type === 'roadmap_payments') {
  //         this.getRoadmaps()
  //         this.getPayments()
  //         this.getActs()
  //         this.getStats()
  //       }

  //       this.$store.commit('CLEAR_SOCKET_STATE')
  //     },
  //     deep: true,
  //     immediate: true
  //   }
  // },
  methods: {
    createPayment () {
      this.payment = cloneDeep(payment)
      this.payment.date = new Date()
      this.paymentModal = true
    },
    async openPayment ({ id }) {
      try {
        const url = `page/payment/${id}`
        const data = await this.$store.dispatch('GET_REQUEST', { url })

        data.pre_paid = !!data.pre_paid
        // format dates
        if (data.date) data.date = formatDefaultDate(data.date)
        // modify roadmap
        if (data.roadmap_payments) {
          data.roadmap_payments = data.roadmap_payments.map((stage) => {
            const current = this.roadmap.find((r) => r.id === stage.roadmap_id)

            if (!current) return { ...stage }

            const {
              name,
              roadmap_start_date,
              roadmap_end_date,
              prepaid_value,
              prepaid_payments_value
            } = current

            return {
              ...stage,
              prepaid_payments_value: prepaid_payments_value - stage.value,
              name,
              roadmap_start_date,
              roadmap_end_date,
              prepaid_value
            }
          })
        }

        this.payment = data
        this.paymentModal = true
      } catch (error) {
        console.log(error)
      }
    },
    async getStats () {
      const { id } = this.$route.params

      try {
        this.statsLoading = true
        const url = `page/payment_stat/${id}`
        this.stats = await this.$store.dispatch('GET_REQUEST', { url })
        this.statsLoading = false
      } catch (error) {
        console.log(error)
        this.statsLoading = false
      }
    },
    async getData () {
      const { id } = this.$route.params

      try {
        this.loading = true
        const contractUrl = `page/${this.type}/${id}`

        this.contract = await this.$store.dispatch('GET_REQUEST', {
          url: contractUrl
        })
        await this.getRoadmaps()
        await this.getActs()
        await this.getPayments()

        this.loading = false
      } catch (error) {
        console.log(error)
        this.nodata = true
        this.loading = false
      }
    },
    async getActs () {
      const { id } = this.$route.params
      const actsUrl = `page/act?contract_id=${id}`

      this.acts = await this.$store.dispatch('GET_REQUEST', {
        url: actsUrl
      })
    },
    async getPayments () {
      const { id } = this.$route.params

      try {
        const url = getPaymentsUrl(
          `page/payment?contract_id=${id}&`,
          this.$store.state.filters.payments
        )
        this.payments = await this.$store.dispatch('GET_REQUEST', { url })
      } catch (error) {
        console.log(error)
      }
    },
    async getRoadmaps () {
      const { id } = this.$route.params
      const roadmapUrl = `page/roadmap_act_cost_lag/${id}`

      this.roadmap = await this.$store.dispatch('GET_REQUEST', {
        url: roadmapUrl
      })
    },
    async deletePayment () {
      try {
        this.deleting = true
        const url = `page/payment?id=${this.payment.id}`
        await this.$store.dispatch('DELETE_REQUEST', { url })

        this.updateData()

        this.$Message.success('Удаление данных выполнено успешно')
        this.deleting = false
        this.paymentModal = false
      } catch (error) {
        console.log(error)
        this.$Message.error('Произошла ошибка при удалении данных')
        this.deleting = false
      }
    },
    async savePayment () {
      const { id } = this.$route.params

      try {
        this.saving = true
        const url = `page/payment?contract_id=${id}`
        const data = this.getPaymentData()
        await this.$store.dispatch('POST_REQUEST', { url, data })
        this.payment = { ...payment }

        this.updateData()

        this.$Message.success('Сохранение данных выполнено успешно')
        this.saving = false
        this.paymentModal = false
      } catch (error) {
        console.log(error)
        this.$Message.error('Произошла ошибка при сохранении данных')
        this.saving = false
      }
    },
    getPaymentData () {
      const {
        value,
        date,
        act_id,
        account_code,
        from_company_id,
        to_company_id,
        id,
        type_id,
        roadmap_payments
      } = this.payment

      const payment = {
        from_company_id: from_company_id || this.contract.customer_id,
        to_company_id: to_company_id || this.contract.performer_id,
        value,
        date: moment(date).format(),
        act_id,
        account_code,
        id,
        type_id,
        roadmap_payments: roadmap_payments.map((r) => ({
          id: r.id,
          roadmap_id: r.roadmap_id,
          value: r.value,
          disabled: r.disabled
        }))
      }

      return payment
    },
    updateData () {
      this.getRoadmaps()
      this.getPayments()
      this.getActs()
      this.getStats()
    },
    getFormattedCosts
  },
  async created () {
    await this.getData()
    this.getStats()

    const { open } = this.$route.query
    if (open) this.openPayment({ id: open })
  }
}
</script>

<style lang="less">
.payments {
  &__stats {
    margin-bottom: 16px;
  }
}

.payments-editor {
  .ivu-modal-body {
    padding-top: 0;
  }

  &__buttons {
    display: flex;
    justify-content: space-between;
  }
}
</style>
